import * as Yup from 'yup'

export const accountIndustrySchema = Yup.object().shape({
  name: Yup.string().max(200, 'validation-name-max').required('validation-required'),
})
